// extracted by mini-css-extract-plugin
export var searchHeader = "_3t-0";
export var searchHeaderDark = "_3t-1";